import React, { useState } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { Modal } from 'rsuite'
import { toast } from '../../../components/CommonComponents/ToastComponent/toast'
import LoaderComponent from '../../CommonComponents/LoaderComponent'
import { doCreateDomain, doGetSameDomainWithName, doJoinOtherDomain } from '../../../redux/actions/domain'

const DomainCreateModal = ({ show, onClose }) => {
  const store = useStore().getState()
  const dispatch = useDispatch()
  const {
    domain: { isLoading },
  } = store

  const [existingDomainInfo, setExistingDomainInfo] = useState({})
  const [createStep, setCreateStep] = useState('basic')
  const [isShowPromt, setIsShowPromt] = useState(false)
  const [isGettingDomain, setIsGettingDomain] = useState(false)
  const [isJoiningDomain, setIsJoiningDomain] = useState(false)
  const [domainName, setDomainName] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [address1, setAddress1] = useState('')
  const [address2, setAddress2] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [zip, setZip] = useState('')
  const [country, setCountry] = useState('')
  const [url, setUrl] = useState('')
  const [phone, setPhone] = useState('')
  const [industry, setIndustry] = useState('')
  const [companySize, setCompanySize] = useState('')

  const searchDomainWithName = (domainName) => {
    setIsGettingDomain(true)
    dispatch(
      doGetSameDomainWithName({
        domainName
      })
    ).then(res => {
      if (!res.isExisting) {
        setExistingDomainInfo({
          isAlreadyJoined: false,
          existingDomain: null,
        })
        setCreateStep('final')
      }
      if (res.isExisting && res.isJoined) {
        toast.show({
          title: 'Warning',
          description: 'You already joined this domain. Please user another domain name!'
        })
        setExistingDomainInfo({
          isAlreadyJoined: true,
          existingDomain: null,
        })
      }
      if (res.isExisting && !res.isJoined) {
        setExistingDomainInfo({
          isAlreadyJoined: false,
          existingDomain: res.domain,
        })
        setIsShowPromt(true)
      }
      setIsGettingDomain(false)
    }).catch(err => {
      setExistingDomainInfo({
        isAlreadyJoined: false,
        existingDomain: null,
      })
      setIsShowPromt(false)
      if (err?.response?.data?.message) {
        toast.show({
          title: 'Warning',
          description: err?.response?.data?.message
        })
      } else {
        toast.show({
          title: 'Warning',
          description: 'Error to get domain!'
        })
      }
      setIsGettingDomain(false)
    })
  }

  const handleCreateDomain = () => {
    if (domainName === '') {
      toast.show({
        title: 'Warning',
        description: 'Domain name is required',
      })
      return
    }

    if (createStep === 'basic') {
      searchDomainWithName(domainName)
      return
    }

    if (companyName === '') {
      toast.show({
        title: 'Warning',
        description: 'Company name is required',
      })
      return
    }
    if (address1 === '' && address2 === '') {
      toast.show({
        title: 'Warning',
        description: 'Address is required',
      })
      return
    }
    if (city === '') {
      toast.show({
        title: 'Warning',
        description: 'City is required',
      })
      return
    }
    if (state === '') {
      toast.show({
        title: 'Warning',
        description: 'State is required',
      })
      return
    }
    if (zip === '') {
      toast.show({
        title: 'Warning',
        description: 'Zip is required',
      })
      return
    }
    if (country === '') {
      toast.show({
        title: 'Warning',
        description: 'Country is required',
      })
      return
    }
    if (url === '') {
      toast.show({
        title: 'Warning',
        description: 'URL is required',
      })
      return
    }
    if (phone === '') {
      toast.show({
        title: 'Warning',
        description: 'Phone is required',
      })
      return
    }
    if (industry === '') {
      toast.show({
        title: 'Warning',
        description: 'Industry is required',
      })
      return
    }
    if (companySize === '') {
      toast.show({
        title: 'Warning',
        description: 'Company size is required',
      })
      return
    }
    dispatch(
      doCreateDomain({
        domainName,
        companyName,
        address1,
        address2,
        city,
        state,
        zip,
        country,
        url,
        phone,
        industry,
        companySize
      })
    ).then(() => {
      handleOnClose()
    })
  }

  const handleClear = () => {
    setCompanyName('')
    setAddress1('')
    setAddress2('')
    setCity('')
    setState('')
    setZip('')
    setCountry('')
    setUrl('')
    setPhone('')
    setIndustry('')
    setCompanySize('')
  }

  const handleExistingDomain = (domain) => {
    if (domain && domain.id) {
      setIsJoiningDomain(true)
      dispatch(
        doJoinOtherDomain({
          domainId: domain.id,
        })
      ).then(() => {
        setIsJoiningDomain(false)
      }).catch(() => {
        setIsJoiningDomain(false)
      })
    }
  }
  const handleTryAnother = () => {
    setIsShowPromt(false)
    setExistingDomainInfo({})
    setCreateStep('basic')
  }

  const isComponnetLoading = isLoading || isGettingDomain || isJoiningDomain

  const handleOnClose = () => {
    setIsShowPromt(false)
    setExistingDomainInfo({})
    setCreateStep('basic')
    setDomainName('')
    handleClear()
    onClose()
  }

  return (
    <Modal
      backdrop={true}
      className="domain-create-modal"
      show={show}
      size="lg"
      onClick={() => { handleOnClose() }}
      onHide={() => { handleOnClose() }}
    >
      <Modal.Header>
        <Modal.Title className='fw-bold text-black'>
          Create New Domain
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={`create-domain border border-2 p-4 rounded ${isComponnetLoading ? 'loading' : ''}`}>
          {isComponnetLoading && <LoaderComponent />}
          {
            createStep === 'basic' && !isShowPromt && (
              <div className="domain-name">
                <div className="row">
                  <div className='item'>
                    <label className='h4 mb-0 text-black mb-2'>Domain Name: </label>
                    <input type="text" className='search-input' value={domainName} onChange={e => setDomainName(e.target.value)} />
                  </div>
                </div>
              </div>
            )
          }
          {
            isShowPromt && (
              <div className="prompt">
                <h3 className='fw-bold mb-0 text-black'>Here is existing domain</h3>
                <div className="row mt-4">
                  <div className="item">
                    <label className='h4 mb-0 text-black mb-2'>Domain Name: </label>
                    <input type="text" className='search-input' disabled value={existingDomainInfo?.existingDomain?.domainName} />
                  </div>
                  <div className="item">
                    <label className='h4 mb-0 text-black mb-2'>Company Name: </label>
                    <input type="text" className='search-input' disabled value={existingDomainInfo?.existingDomain?.companyName} />
                  </div>
                </div>
                <div className='row'>
                  <div className="item action">
                    <button type="button" className="h4 mb-0 p-4 pt-3 pb-3 btn-green rounded" onClick={() => handleExistingDomain(existingDomainInfo?.existingDomain)}>
                      Join this domain
                    </button>
                    <button type="button" className="ms-3 h4 mb-0 p-4 pt-3 pb-3 bg-gray text-white rounded" onClick={handleTryAnother}>
                      Try Another New One
                    </button>
                  </div>
                </div>
              </div>
            )
          }
          {
            createStep === 'final' && (
              <div className="content create-new">
                <div className="row">
                  <div className='item d-flex align-items-center'>
                    <label className='h4 mb-0 text-black mb-2 w-50'>Domain Name:</label>
                    <input type="text" className='search-input' value={domainName} disabled onChange={e => setDomainName(e.target.value)} />
                  </div>
                  <div className='item d-flex align-items-center'>
                    <label className='h4 mb-0 text-black mb-2 w-50'>Company Name: </label>
                    <input type="text" className='search-input' value={companyName} onChange={e => setCompanyName(e.target.value)} />
                  </div>
                </div>
                <div className="row">
                  <div className='item d-flex align-items-center'>
                    <label className='h4 mb-0 text-black mb-2 w-50'>Address 1: </label>
                    <input type="text" className='search-input' value={address1} onChange={e => setAddress1(e.target.value)} />
                  </div>
                  <div className='item d-flex align-items-center'>
                    <label className='h4 mb-0 text-black mb-2 w-50'>Address 2: </label>
                    <input type="text" className='search-input' value={address2} onChange={e => setAddress2(e.target.value)} />
                  </div>
                </div>
                <div className="row">
                  <div className='item d-flex align-items-center'>
                    <label className='h4 mb-0 text-black mb-2 w-50'>City: </label>
                    <input type="text" className='search-input' value={city} onChange={e => setCity(e.target.value)} />
                  </div>
                  <div className='item d-flex align-items-center'>
                    <label className='h4 mb-0 text-black mb-2 w-50'>State: </label>
                    <input type="text" className='search-input' value={state} onChange={e => setState(e.target.value)} />
                  </div>
                </div>
                <div className="row">
                  <div className='item d-flex align-items-center'>
                    <label className='h4 mb-0 text-black mb-2 w-50'>Zip: </label>
                    <input type="text" className='search-input' value={zip} onChange={e => setZip(e.target.value)} />
                  </div>
                  <div className='item d-flex align-items-center'>
                    <label className='h4 mb-0 text-black mb-2 w-50'>Country: </label>
                    <input type="text" className='search-input' value={country} onChange={e => setCountry(e.target.value)} />
                  </div>
                </div>
                <div className="row">
                  <div className='item d-flex align-items-center'>
                    <label className='h4 mb-0 text-black mb-2 w-50'>Url: </label>
                    <input type="text" className='search-input' value={url} onChange={e => setUrl(e.target.value)} />
                  </div>
                  <div className='item d-flex align-items-center'>
                    <label className='h4 mb-0 text-black mb-2 w-50'>Phone: </label>
                    <input type="text" className='search-input' value={phone} onChange={e => setPhone(e.target.value)} />
                  </div>
                </div>
                <div className="row">
                  <div className='item d-flex align-items-center'>
                    <label className='h4 mb-0 text-black mb-2 w-50'>Industry: </label>
                    <input type="text" className='search-input' value={industry} onChange={e => setIndustry(e.target.value)} />
                  </div>
                  <div className='item d-flex align-items-center'>
                    <label className='h4 mb-0 text-black mb-2 w-50'>Company Size: </label>
                    <input type="text" className='search-input' value={companySize} onChange={e => setCompanySize(e.target.value)} />
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex gap-3 justify-content-end">
          {
            createStep === 'final' && (
              <>
                <button type="button" disabled={isComponnetLoading} className="h4 mb-0 p-5 pt-3 pb-3 bg-red text-white rounded" onClick={handleClear}>
                  Clear All
                </button>
                <button type="button" disabled={isComponnetLoading} className="h4 mb-0 p-5 pt-3 pb-3 bg-gray text-white rounded" onClick={handleTryAnother}>
                  Try New Domain
                </button>
              </>
            )
          }
          {
            !isShowPromt && (
              <button type="button" disabled={isComponnetLoading} className="h4 mb-0 p-5 pt-3 pb-3 btn-green rounded" onClick={handleCreateDomain}>
                Create Domain
              </button>
            )
          }
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default DomainCreateModal